// src/supabaseClient.js - Simplified for quiz-only functionality
import { createClient } from '@supabase/supabase-js';

// Access environment variables using process.env
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Debug logs to check if environment variables are loaded
console.log('Environment variables:');
console.log('- Supabase URL:', supabaseUrl ? 'Set (value hidden)' : 'NOT SET');
console.log('- Supabase Anon Key:', supabaseAnonKey ? 'Set (value hidden)' : 'NOT SET');

// Create the Supabase client
let supabase;

try {
  if (!supabaseUrl || !supabaseAnonKey) {
    throw new Error('Missing Supabase credentials');
  }
  
  supabase = createClient(supabaseUrl, supabaseAnonKey);
  console.log('Supabase client initialized successfully');
} catch (error) {
  console.error('Supabase client initialization error:', error.message);
  
  // Create a minimal mock client to prevent application crashes
  supabase = {
    from: (table) => ({
      select: (columns) => ({
        order: () => Promise.resolve({ data: [], error: null }),
        eq: () => ({
          single: () => Promise.resolve({ data: null, error: null })
        }),
        limit: () => Promise.resolve({ data: [], error: null })
      })
    })
  };
  
  console.warn('Using mock Supabase client - application will not function correctly');
}

// Export the Supabase client
export { supabase };